// Global Types
import type {
  $Translate,
} from 'common.language';
import type {
  $FullChampionship,
  $Model,
} from 'common.data';

// Global Enums
import {
  RegattaStatus,
} from 'common.data';

// Global Components
import * as React from 'react';
import {
  NavLink,
} from 'react-router-dom';

// Helpers
import _ from 'lodash';
import {
  getImageUrl,
} from '@vroskus/library-helpers/dist/browser';
import config from '../../../config';

// Types
type $Props = $Translate & {
  basePath: string;
  item: $FullChampionship;
};

class ChampionshipsListItemView extends React.Component<$Props> {
  renderItemProgress(item: $FullChampionship) {
    const {
      t,
    } = this.props;

    const allRegattasQuantity: number = item.Regattas.length;

    const endedRegattasQuantity: number = _.filter(
      item.Regattas,
      (regatta: $Model<'Regatta'>) => _.includes(
        [
          RegattaStatus.canceled,
          RegattaStatus.ended,
        ],
        regatta.Status,
      ),
    ).length;

    const ratio: number = Math.round((endedRegattasQuantity / allRegattasQuantity) * 100);

    return (
      <>
        <div className={'w-full bg-gray-200 h-2.5'}>
          <div
            className={'bg-blue h-2.5'}
            style={{
              width: `${ratio}%`,
            }}
          />
        </div>
        <div className={'flex items-spread'}>
          <span>
            <small className={'uppercase'}>
              {`${t('Regattas')}: `}
            </small>
            <span className={'mr-3'}>
              {item.Regattas.length}
            </span>
            <small className={'uppercase'}>
              {`${t('Ended')}: `}
            </small>
            <span>
              {endedRegattasQuantity}
            </span>
          </span>
          <span className={'ml-auto'}>
            {`${ratio}%`}
          </span>
        </div>
      </>
    );
  }

  renderItemButton(item: $FullChampionship) {
    const {
      basePath,
      t,
    } = this.props;

    return (
      <NavLink
        className={'btn btn_primary btn_outlined uppercase px-2 py-1'}
        end
        title={t('Championship page')}
        to={`${basePath}/${item.Slug || item.id}`}
      >
        <em className={'la la-trophy text-2xl'} />
      </NavLink>
    );
  }

  renderContent(className: string) {
    const {
      item,
      t,
    } = this.props;

    const imageUrl: string = getImageUrl({
      cdnUrl: config.CDN_URL,
      image: item.Image,
      size: 'min',
      undefinedImage: 'championship.png',
    });

    return (
      <div className={`flex flex-row items-center bg-white rounded-lg py-3 px-5 ${className}`}>
        <div className={'hidden md:table-cell w-14'}>
          <img
            alt={t('Logo')}
            className={'max-h-10'}
            src={imageUrl}
          />
        </div>
        <div className={'lg:hidden w-full'}>
          <div className={'mb-2'}>
            <div className={'flex flex-row items-center'}>
              {item.Image && (
                <div className={'md:hidden flex-none w-10 mr-2'}>
                  <img
                    alt={t('Logo')}
                    src={imageUrl}
                  />
                </div>
              )}
              <div className={'flex flex-row items-center w-full'}>
                <div className={'grow'}>
                  <h3 className={'text-base md:text-lg font-semibold'}>
                    {item.Name}
                  </h3>
                  <div className={'text-sm text-gray-600'}>
                    {item.OrganizerName}
                  </div>
                </div>
                <div className={'lg:hidden ml-3'}>
                  {this.renderItemButton(item)}
                </div>
              </div>
            </div>
          </div>
          <div className={'overflow-x-auto w-full'}>
            {this.renderItemProgress(item)}
          </div>
        </div>
        <div className={'hidden lg:table-cell grow'}>
          <h3 className={'text-lg font-semibold'}>
            {item.Name}
          </h3>
          <div className={'text-sm text-gray-600'}>
            {item.OrganizerName}
          </div>
        </div>
        <div className={'hidden lg:table-cell w-full lg:w-1/4 px-0 lg:pl-3 lg:pr-5'}>
          {this.renderItemProgress(item)}
        </div>
        <div className={'hidden lg:table-cell text-right'}>
          {this.renderItemButton(item)}
        </div>
      </div>
    );
  }

  render() {
    const {
      basePath,
      item,
      t,
    } = this.props;

    return (
      <div
        className={'ChampionshipsListItem mb-2'}
        id={`ChampionshipsListItem-${item.id}`}
      >
        <NavLink
          className={''}
          end
          title={t('Championship page')}
          to={`${basePath}/${item.Slug || item.id}`}
        >
          {this.renderContent('hover:bg-blue-50')}
        </NavLink>
      </div>
    );
  }
}

export default ChampionshipsListItemView;
